/**
 * Represents the user's locale
 */
export const enum Locale {
  EN = 'en',
  JA = 'ja',
}
